import React from 'react';
import styled from 'styled-components';

const Label = styled.span`
    display: inline;
    padding: .2em .6em .3em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    color :#fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25em;
    background-color: #337ab7;
    user-select: none;
`;

export default Label;
